import type { ChartPoint, ProgressChartModel } from '../types'

/** Headroom above the busiest period so its point isn't pinned to the top edge. */
const DOMAIN_HEADROOM = 1.15

/**
 * The All Sports trend: games played per period as the plotted value. A period
 * with no games is a real 0 on this line, not a gap.
 */
export const buildGamesPlayedChart = (
  gamesChart: ChartPoint[]
): ProgressChartModel => {
  const points = gamesChart.map((point) => ({
    ...point,
    value: point.gamesPlayed,
  }))
  const totalGames = points.reduce((sum, point) => sum + point.gamesPlayed, 0)
  const best = points.reduce<ChartPoint | null>(
    (top, point) =>
      point.gamesPlayed > 0 && (!top || point.gamesPlayed > top.gamesPlayed)
        ? point
        : top,
    null
  )
  const busiest = best?.gamesPlayed ?? 0

  return {
    points,
    domain: { min: 0, max: busiest > 0 ? busiest * DOMAIN_HEADROOM : 1 },
    aggregate: totalGames,
    best,
    totalGames,
  }
}
